module.exports = __webpack_public_path__ + "static/img/block02.0a870534.png";